// AUTO-GENERATED from dictionary.mjs by generate/pack_ranges.mjs
// Repeating group ranges (5000-50FF Curves, 6000-60FF Overlays). Used when exact tag lookup fails.

export const rangeEntries = [
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 5,
        vr: "US",
        vm: "1",
        name: "RETIRED_CurveDimensions"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 16,
        vr: "US",
        vm: "1",
        name: "RETIRED_NumberOfPoints"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 32,
        vr: "CS",
        vm: "1",
        name: "RETIRED_TypeOfData"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 34,
        vr: "LO",
        vm: "1",
        name: "RETIRED_CurveDescription"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 48,
        vr: "SH",
        vm: "1-n",
        name: "RETIRED_AxisUnits"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 64,
        vr: "SH",
        vm: "1-n",
        name: "RETIRED_AxisLabels"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 259,
        vr: "US",
        vm: "1",
        name: "RETIRED_DataValueRepresentation"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 260,
        vr: "US",
        vm: "1-n",
        name: "RETIRED_MinimumCoordinateValue"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 261,
        vr: "US",
        vm: "1-n",
        name: "RETIRED_MaximumCoordinateValue"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 262,
        vr: "SH",
        vm: "1-n",
        name: "RETIRED_CurveRange"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 272,
        vr: "US",
        vm: "1-n",
        name: "RETIRED_CurveDataDescriptor"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 274,
        vr: "US",
        vm: "1-n",
        name: "RETIRED_CoordinateStartValue"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 276,
        vr: "US",
        vm: "1-n",
        name: "RETIRED_CoordinateStepValue"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 4097,
        vr: "CS",
        vm: "1",
        name: "RETIRED_CurveActivationLayer"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 8192,
        vr: "US",
        vm: "1",
        name: "RETIRED_AudioType"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 8194,
        vr: "US",
        vm: "1",
        name: "RETIRED_AudioSampleFormat"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 8196,
        vr: "US",
        vm: "1",
        name: "RETIRED_NumberOfChannels"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 8198,
        vr: "UL",
        vm: "1",
        name: "RETIRED_NumberOfSamples"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 8200,
        vr: "UL",
        vm: "1",
        name: "RETIRED_SampleRate"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 8202,
        vr: "UL",
        vm: "1",
        name: "RETIRED_TotalTime"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 8204,
        vr: "ox",
        vm: "1",
        name: "RETIRED_AudioSampleData"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 8206,
        vr: "LT",
        vm: "1",
        name: "RETIRED_AudioComments"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 9472,
        vr: "LO",
        vm: "1",
        name: "RETIRED_CurveLabel"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 9728,
        vr: "SQ",
        vm: "1",
        name: "RETIRED_CurveReferencedOverlaySequence"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 9744,
        vr: "US",
        vm: "1",
        name: "RETIRED_CurveReferencedOverlayGroup"
    },
    {
        groupMin: 20480,
        groupMax: 20735,
        elem: 12288,
        vr: "ox",
        vm: "1",
        name: "RETIRED_CurveData"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 16,
        vr: "US",
        vm: "1",
        name: "OverlayRows"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 17,
        vr: "US",
        vm: "1",
        name: "OverlayColumns"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 18,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayPlanes"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 21,
        vr: "IS",
        vm: "1",
        name: "NumberOfFramesInOverlay"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 34,
        vr: "LO",
        vm: "1",
        name: "OverlayDescription"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 64,
        vr: "CS",
        vm: "1",
        name: "OverlayType"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 69,
        vr: "LO",
        vm: "1",
        name: "OverlaySubtype"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 80,
        vr: "SS",
        vm: "2",
        name: "OverlayOrigin"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 81,
        vr: "US",
        vm: "1",
        name: "ImageFrameOrigin"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 82,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayPlaneOrigin"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 96,
        vr: "CS",
        vm: "1",
        name: "RETIRED_OverlayCompressionCode"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 97,
        vr: "SH",
        vm: "1",
        name: "RETIRED_OverlayCompressionOriginator"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 98,
        vr: "SH",
        vm: "1",
        name: "RETIRED_OverlayCompressionLabel"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 99,
        vr: "CS",
        vm: "1",
        name: "RETIRED_OverlayCompressionDescription"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 102,
        vr: "AT",
        vm: "1-n",
        name: "RETIRED_OverlayCompressionStepPointers"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 104,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayRepeatInterval"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 105,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayBitsGrouped"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 256,
        vr: "US",
        vm: "1",
        name: "OverlayBitsAllocated"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 258,
        vr: "US",
        vm: "1",
        name: "OverlayBitPosition"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 272,
        vr: "CS",
        vm: "1",
        name: "RETIRED_OverlayFormat"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 512,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayLocation"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 2048,
        vr: "CS",
        vm: "1-n",
        name: "RETIRED_OverlayCodeLabel"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 2050,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayNumberOfTables"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 2051,
        vr: "AT",
        vm: "1-n",
        name: "RETIRED_OverlayCodeTableLocation"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 2052,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayBitsForCodeWord"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4097,
        vr: "CS",
        vm: "1",
        name: "OverlayActivationLayer"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4352,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayDescriptorGray"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4353,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayDescriptorRed"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4354,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayDescriptorGreen"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4355,
        vr: "US",
        vm: "1",
        name: "RETIRED_OverlayDescriptorBlue"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4608,
        vr: "US",
        vm: "1-n",
        name: "RETIRED_OverlaysGray"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4609,
        vr: "US",
        vm: "1-n",
        name: "RETIRED_OverlaysRed"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4610,
        vr: "US",
        vm: "1-n",
        name: "RETIRED_OverlaysGreen"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4611,
        vr: "US",
        vm: "1-n",
        name: "RETIRED_OverlaysBlue"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4865,
        vr: "IS",
        vm: "1",
        name: "ROIArea"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4866,
        vr: "DS",
        vm: "1",
        name: "ROIMean"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 4867,
        vr: "DS",
        vm: "1",
        name: "ROIStandardDeviation"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 5376,
        vr: "LO",
        vm: "1",
        name: "OverlayLabel"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 12288,
        vr: "ox",
        vm: "1",
        name: "OverlayData"
    },
    {
        groupMin: 24576,
        groupMax: 24831,
        elem: 16384,
        vr: "LT",
        vm: "1",
        name: "RETIRED_OverlayComments"
    },
    {
        groupMin: 32512,
        groupMax: 32767,
        elem: 16,
        vr: "ox",
        vm: "1",
        name: "RETIRED_VariablePixelData"
    },
    {
        groupMin: 32512,
        groupMax: 32767,
        elem: 17,
        vr: "US",
        vm: "1",
        name: "RETIRED_VariableNextDataGroup"
    },
    {
        groupMin: 32512,
        groupMax: 32767,
        elem: 32,
        vr: "OW",
        vm: "1",
        name: "RETIRED_VariableCoefficientsSDVN"
    },
    {
        groupMin: 32512,
        groupMax: 32767,
        elem: 48,
        vr: "OW",
        vm: "1",
        name: "RETIRED_VariableCoefficientsSDHN"
    },
    {
        groupMin: 32512,
        groupMax: 32767,
        elem: 64,
        vr: "OW",
        vm: "1",
        name: "RETIRED_VariableCoefficientsSDDN"
    }
];
